module.exports = __webpack_public_path__ + "img/gather sleeve ruffle.467c5082.png";